// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_96-3";
export var contentContainer = "_96-0";
export var editorContainer = "_96-1";
export var quillInputForm = "_96-2";
export var zoneDivider = "_96-4";